import React, { useRef, useState } from "react";
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';
import { emojisplosion } from "emojisplosion";
import { useMixpanel } from 'gatsby-plugin-mixpanel'

import "./emoji-card.css"
import "../buttons/primary-button.css"

const EmojiCard = ({ emoji }) => {
    const emojiRef = useRef(null);
    const [copied, setCopied] = useState(false);
    const { language } = useI18next();
    const { t } = useTranslation();
    const mixpanel = useMixpanel()

    const handleCopyToClipboard = async (event) => {
        const element = emojiRef.current;

        mixpanel.track('copy_tap', {
            source: 'emoji_page',
            emoji: emoji.url,
            language: language
          });

        emojisplosion({
            emojis: [emoji.emoji],
            physics: {
                gravity: 0.65,
            },
            position() {
                const rect = element.getBoundingClientRect();

                return {
                    x: rect.left + rect.width / 2 + 30,
                    y: rect.top + rect.height / 2,
                };
            },
        });
        const emojiToCopy = emoji.emoji;
        try {
            await navigator.clipboard.writeText(emojiToCopy);
            setCopied(true);
            console.log("Emoji Copied to Clipboard:", emojiToCopy);
        } catch (err) {
            console.error("Unable to copy to clipboard", err);
        }
    };

    return (
        <div className="card border">
            <div className="card-content">
                <div className="card-content-line">
                    <div className="emoji mb-4">{emoji.emoji}</div>
                </div>
                <div className="card-content-line">
                    <button onClick={handleCopyToClipboard} className="primary-button primary-button-green" ref={emojiRef}>
                        {copied ? t('emoji-detail.copied', { lng: language }) : t('emoji-detail.copy-to-clipboard', { lng: language })}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EmojiCard